(function(){
  'use strict';
  var variant=new URLSearchParams(location.search).get('wd_buy')||'a';
  if(!/^[ab]$/.test(variant||''))return;
  document.body.classList.add('wd-buy-'+variant);
  var data={1:{base:2190,sub:2190,compare:3690},3:{base:5390,sub:4582,compare:8990},6:{base:7890,sub:6707,compare:13190}};
  function yen(n){return 'NT$'+n.toLocaleString('zh-TW');}
  function update(){
    var on=document.querySelector('#wdSubToggle')?.getAttribute('aria-checked')==='true';
    document.querySelectorAll('.butOption_row').forEach(function(row){
      var count=Number(row.dataset.option),p=data[count];if(!p)return;
      var total=on&&count!==1?p.sub:p.base;
      var signature=variant+':'+total;
      if(row.dataset.wdUnitState===signature)return;
      row.dataset.wdUnitState=signature;
      var old=row.querySelector('.wdp-price');if(old)old.remove();
      var block=document.createElement('div');block.className='wdp-price';
      var badge=variant==='a'?'<span class="wdp-discount">'+(on&&count!==1?'49':'40')+'%OFF</span>':'<span class="wdp-discount">40%OFF</span>'+(on&&count!==1?'<span class="wdp-extra">再享85折</span>':'');
      block.innerHTML='<div class="wdp-price-top"><span class="wdp-label">每片</span>'+badge+'</div><div class="wdp-price-main"><del>'+yen(Math.round(p.compare/count))+'</del><strong>'+yen(Math.round(total/count))+'</strong><span>/片</span></div>'+(variant==='b'?'<div class="wdp-total">'+count+'片合計 '+yen(total)+'</div>':'');
      row.querySelector('.buyPrice_row').insertAdjacentElement('afterend',block);
      if(variant==='a'){
        var delivered=row.querySelector('.pkg_quantity_text');
        if(delivered){delivered.textContent='共'+count+'片配送';block.insertAdjacentElement('afterend',delivered);}
      }
      if(count!==1&&!row.querySelector('.wdp-free')){
        var mark=document.createElement('span');mark.className='wdp-free';mark.textContent='免費';mark.setAttribute('aria-label',count===6?'下方3片免費':'下方1片免費');
        row.querySelector('.buy_prodbx').appendChild(mark);
      }
    });
  }
  function start(){
    update();
    document.addEventListener('click',function(event){if(event.target.closest('#wdSubToggle,.butOption_row'))setTimeout(update,0);});
    // CTA wired to theme cart
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
